import ranges from './ranges'

var segments = Object.keys(ranges)

export default segments
